<template>
  <div class="card" :class="size_" :style="styleObject">

    <slot name="media">
      <img class="card-slot" src="../assets/logo.png" alt="">
    </slot>

    <div class="card-title">
      {{title}}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'card',
    props: ['title','size','cardStyle'],
    data() {
      return {
        size_: 'sm',
        styleObject: {
          color: '#000000',
          fontSize: '13px'
        }
      }
    },
    created() {
      if(this.size){
        this.size_ = this.size
      }
      if(this.cardStyle){
        this.styleObject = this.cardStyle
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .card{
    background: #fff;
    height: auto;
    float: left;
    width: 25%;
    text-align: center;
    position: relative;
    z-index: 0;
    overflow: hidden;
    box-shadow: 0 3px 8px -6px rgba(0,0,0,.1);
    box-sizing: border-box;
    margin: 20px;
    padding: 10px;
    border-radius: 3px;
  }
  .card:hover{
    box-shadow: 0 0 38px rgba(0,0,0,.08) inset;
    -webkit-transition: all .15s ease;
    transition: all .15s ease;
    cursor: pointer;
  }
  .card:first-child:before {
    border-left: none;
  }
  .card:last-child:before {
    border-right: 1px solid rgba(0,0,0,.1);
  }
  .card:before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    pointer-events: none;
  }
  .card-title{
    white-space:nowrap;
    text-overflow: ellipsis;
  }
  .sm{width:100px}
  .md{width:200px}
  .lg{width:400px}
  .card-slot{
    max-width: 150px;
    text-align: center;
    margin: 0 auto;
    overflow: hidden;
    height: 80%;
  }
</style>



// WEBPACK FOOTER //
// card.vue?19ce9781